import React, { useCallback } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/Row';
import styled from 'styled-components';

interface AddressBoxProps {
  place: google.maps.places.AutocompletePrediction;
  onClick?: (place: google.maps.places.AutocompletePrediction) => void;
}

const AddressTitle = styled.h5`
  color: ${({ theme }) => theme.colors.deepPurple};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 131.25% */
  letter-spacing: 0.4px;
`;

const AddressSubTitle = styled.h6`
  color: ${({ theme }) => theme.colors.lightGrey};
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 138.462% */
  letter-spacing: 0.4px;
`;

const StyledAddressBox = styled(Row)`
  padding-top: 14px;
  padding-bottom: 10px;
  border-top: 0.5px solid ${({ theme }) => theme.colors.ghostWhite};
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.ghostWhite};
`;

const AddressBox = ({ place, onClick }: AddressBoxProps) => {
  const onClickAddress = useCallback(() => {
    onClick?.(place);
  }, []);

  return (
    <StyledAddressBox onClick={onClickAddress}>
      <Col>
        <AddressTitle>{place.structured_formatting.main_text}</AddressTitle>
        <AddressSubTitle>{place.structured_formatting.secondary_text}</AddressSubTitle>
      </Col>
    </StyledAddressBox>
  );
};

export default AddressBox;
